import _asyncToGenerator from "F:/Lee/Desktop/0206/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getsysset } from "@/http/api.js";
import Nav from "_c/Nav/index.vue";
import Footer from "_c/Footer/index.vue";
export default {
  components: {
    Nav: Nav,
    Footer: Footer
  },
  data: function data() {
    return {
      setting: {
        title: "",
        keywords: "",
        description: ""
      }
    };
  },
  metaInfo: function metaInfo() {
    return {
      title: this.setting.title,
      meta: [{
        name: "keywords",
        content: this.setting.keywords
      }, {
        name: "description",
        content: this.setting.description
      }]
    };
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return getsysset();

            case 3:
              res = _context.sent;

              if (res.return_code === "SUCCESS") {
                // this.info = res.data;
                _this.$store.commit("SAVE_SYS_INFO", res.data);

                _this.setting.keywords = res.data.keyword;
                _this.setting.description = res.data.desription;
                _this.setting.title = res.data.title;
              }

              _context.next = 9;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }))();
  }
};